"use strict";
let lastHash = '';
const upToDate = function upToDate() {
    return lastHash.indexOf(__webpack_hash__) >= 0;
};
const clientEmitter = require('webpack/hot/emitter');
clientEmitter.on('webpackHotUpdate', function (currentHash) {
    const previousHash = lastHash;
    lastHash = currentHash;
    if (upToDate()) {
        return;
    }
    console.clear();
    // console.log('%c Hot Reloaded: ' + previousHash + ' > ' + currentHash, 'color: #FF00FF');
});
